<div class="sectionbar">
  <app-aftale-nav></app-aftale-nav>
  <div class="sectionbar__actions">
    <button class="btn-icon green" matTooltip="Opret serviceaftale" [routerLink]="'/aftale/create'">
      <mat-icon svgIcon="add"></mat-icon>
      <span>Opret serviceaftale</span>
    </button>
  </div>
</div>

<div class="topbar">
  <div>
    <h1>Mine seneste</h1>
  </div>
  <div class="topbar__actions"></div>
</div>
<div class="page__content subscriptions subscriptions--list">
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z0 has-notifications">
    <ng-container matColumnDef="actions">
      <th mat-header-cell class="hidden-cell" *matHeaderCellDef></th>
      <td mat-cell class="hidden-cell" [class.hidden-cell--pinned]="button(serviceaftale) > 0" *matCellDef="let serviceaftale">
        <button
          type="button"
          class="btn-icon opacity-hover"
          [class.opfoelgning-bookmark]="button(serviceaftale)"
          (click)="opfoelgning($event, serviceaftale)"
          [disabled]="!canWrite"
          >
          <app-opfoelgning-button [opfoelgningList]="serviceaftale.opfoelgningList"></app-opfoelgning-button>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="produkt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <mat-icon [svgIcon]="getProductIcon(serviceaftale)" [matTooltip]="getProductIcon(serviceaftale) | titlecase"></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <mat-icon [matTooltip]="serviceaftale.serviceaftaleState.text" [svgIcon]="getStatusIcon(serviceaftale)"></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="kundenr">
      <th mat-header-cell *matHeaderCellDef>Kundenr</th>
      <td mat-cell *matCellDef="let serviceaftale">
        @if (serviceaftale.kunde) {
          <div>{{ serviceaftale.kunde ? serviceaftale.kunde.okKundeNr : '' }}</div>
        }
        @if (!serviceaftale.kunde) {
          <div>
            <span matTooltip="Ingen data i G4">N/A</span>
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="kundeNavn">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.kunde ? serviceaftale.kunde.anlaegsadresse?.name : 'N/A' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="okKundeAftaleNr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Aftalenr</th>
      <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.okKundeAftaleNr }}</td>
    </ng-container>
    <ng-container matColumnDef="adresse">
      <th mat-header-cell *matHeaderCellDef>Anlægsadresse</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <div class="truncate" [matTooltip]="concatAdresseLokation(serviceaftale)">
          {{ concatAdresseLokation(serviceaftale) }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="telefon">
      <th mat-header-cell *matHeaderCellDef>Telefonnr.</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.kunde?.anlaegsadresse?.phone ? ($safeNavigationMigration(serviceaftale.kunde.anlaegsadresse?.phone) | dkPhoneNumber) : '' }}
        {{ serviceaftale.kunde?.anlaegsadresse?.phone && serviceaftale.kunde?.anlaegsadresse?.mobile ? '/' : '' }}
        {{ serviceaftale.kunde?.anlaegsadresse?.mobile ? ($safeNavigationMigration(serviceaftale.kunde.anlaegsadresse?.mobile) | dkPhoneNumber) : '' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="modifiedOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Senest ændret</th>
      <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.modifiedOn | date: 'shortDate' }}</td>
    </ng-container>
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Oprettet</th>
      <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.createdOn | date: 'shortDate' }}</td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.partner?.name }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [appScrollToRow]="prevRow"
      [rowId]="row.okKundeAftaleNr"
      (rowActive)="highLight($event)"
      (click)="onRowClick(row)"
      (dblclick)="onRowDblClick(row)"
      [class.active]="globalActiveRowID == row.id"
    ></tr>
  </table>
</div>
@if (quickViewOpen) {
  <div class="quick-view" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="closeQuickView()" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <app-quickview [serviceaftale]="selectedaftale"></app-quickview>
    <div class="quick-view__bottom">
      <app-opfoelgning-action
        [opfoelgningList]="selectedaftale.opfoelgningList"
        (opfoelgningChange)="onOpfoelgningChanged($event)"
        [entityNo]="selectedaftale.serviceAftaleNo"
      ></app-opfoelgning-action>
      <button mat-raised-button color="primary" (click)="onRowDblClick(selectedaftale)">Åben aftalen</button>
    </div>
  </div>
}
